import React from 'react';

export default function _502SectionHttpCodesLightReverse1() {
    return (
        <React.Fragment>
            <>
                <section className="py-10 bg-gray-50 overflow-hidden">
  <div className="container mx-auto px-4">
    <div className="py-20 px-8 bg-white rounded-3xl">
      <div className="pb-32 md:pb-64 max-w-7xl mx-auto">
        <div className="md:max-w-md mx-auto text-center">
          <img className="mb-32 md:mb-64 mx-auto h-60" src="https://static.shuffle.dev/uploads/files/bd/bd9a85b8a4fa1ba404318e6dc3a1410c26c46d6a/TextOnly.png" alt />
          <h3 className="font-heading text-2xl text-blue-500 font-black tracking-tight">502</h3>
          <h2 className="font-heading mb-6 text-4xl md:text-5xl lg:text-6xl text-gray-900 font-black tracking-tight">Internal Server Error</h2>
          <p className="mb-6 text-gray-500 font-bold">Please contact your administrator</p>
          <div className="flex flex-wrap justify-center -m-2">
            <div className="w-full md:w-auto p-2"><a className="block w-full px-4 py-2.5 text-sm text-center text-white font-bold bg-blue-500 hover:bg-blue-600 focus:ring-4 focus:ring-blue-200 rounded-full" href="#">Go back to Homepage</a></div>
            <div className="w-full md:w-auto p-2"><a className="block w-full px-4 py-2.5 text-sm text-center text-gray-900 font-bold bg-gray-50 hover:bg-gray-200 focus:ring-4 focus:ring-gray-200 rounded-full" href="#">Try Again</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

